<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>História</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
      </div>

    </mat-toolbar>

  </mat-card>

  <mat-card>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>Texto</div>
        </ng-template>

        <div *ngIf="entityForm">
          <ckeditor [editor]="Editor" [config]="editorConfig" [formControl]="entityForm.controls.text"
            (ready)="onReady($event)" (change)="onChange($event)"> </ckeditor>
        </div>

      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>HTML</div>
        </ng-template>


        <textarea class='text-area' autocomplete="off" [(ngModel)]="htmlContent" [ngModelOptions]="{ standalone: true }"
          (input)="entityForm.controls.text.setValue(htmlContent, { emitEvent: false })">
          </textarea>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div>Imagens</div>
        </ng-template>

        <mat-card class="image-area">
          <app-file-manager [image_path]="'site_pub/history'">
          </app-file-manager>
        </mat-card>

      </mat-tab>

    </mat-tab-group>
  </mat-card>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button matTooltip='Geravar' mat-raised-button (click)="saveData()">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>


</div>